export default "/assets/images/mila-air-3-alt.webp?9b493d52aa2080d227bc1b05647b085d";